import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Row, Col } from 'antd';
import Format from '../../utils/format';
import { withTranslation } from 'react-i18next';

@inject(
    'templateStore',
    'TransactionStore',
    'webSettingStore'
)
@observer
class OrderDetailModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
    }

    // ON CLICK

    close = () => {
        this.props.TransactionStore.setshowOrderDetailModal(false);
    }

    // ON RENDER

    showImageOnRender = (order) => {
        return (
            <React.Fragment>
                {
                    order.imageUrl === ''
                        ?
                        <img className='stm-item-image' src='https://via.placeholder.com/56' alt={order.taskName} />
                        :
                        <img className='stm-item-image' src={order.imageUrl} alt={order.taskName} />
                }
            </React.Fragment>
        )
    }

    render() {
        const { activeTemplate } = this.props.templateStore;

        const { data: webSettting } = this.props.webSettingStore;

        const {
            orderDetail
        } = this.props.TransactionStore;

        return (
            <>
                {
                    activeTemplate
                        ?
                        <>
                            {
                                webSettting
                                    ?
                                    <>
                                        {
                                            orderDetail === null
                                                ?
                                                null
                                                :
                                                <Row className='stm-padding-16 stm-margin-bottom-20'>
                                                    <Col span={24} className='stm-margin-bottom-8'>
                                                        <Row className='stm-margin-bottom-0'>
                                                            <Col span={4} className='stm-text-align-center'>
                                                                {this.showImageOnRender(orderDetail)}
                                                            </Col>
                                                            <Col span={16} className='stm-margin-bottom-0 stm-padding-5-10'>
                                                                <Row>
                                                                    <Col
                                                                        span={24}
                                                                        className='stm-margin-bottom-5'
                                                                        style={{
                                                                            fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                                            color: activeTemplate.templateSetting.label.color,
                                                                            fontSize: activeTemplate.templateSetting.label.fontSize,
                                                                            lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                                                                        }}
                                                                    >
                                                                        <span>
                                                                            {
                                                                                orderDetail.quantity < 2
                                                                                    ?
                                                                                    orderDetail.taskName
                                                                                    :
                                                                                    `${orderDetail.taskName} x${orderDetail.quantity}`
                                                                            }
                                                                        </span>
                                                                    </Col>
                                                                    <Col
                                                                        span={24}
                                                                        className='stm-margin-bottom-5'
                                                                        style={{
                                                                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                            color: activeTemplate.templateSetting.text.color,
                                                                            fontSize: activeTemplate.templateSetting.text.fontSize,
                                                                            lineHeight: `${activeTemplate.templateSetting.text.fontSize + 12}px`
                                                                        }}
                                                                    >
                                                                        <span>Created At: {orderDetail.creationTime}</span>
                                                                    </Col>
                                                                    <Col
                                                                        span={24}
                                                                        className='stm-margin-bottom-5'
                                                                        style={{
                                                                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                            color: activeTemplate.templateSetting.text.color,
                                                                            fontSize: activeTemplate.templateSetting.text.fontSize,
                                                                            lineHeight: `${activeTemplate.templateSetting.text.fontSize + 4}px`
                                                                        }}
                                                                    >
                                                                        <span>
                                                                            {
                                                                                orderDetail.amount === 0
                                                                                    ?
                                                                                    null
                                                                                    :
                                                                                    `${webSettting.currencyCode} ${Format.Currency(orderDetail.amount)}`
                                                                            }
                                                                        </span>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                            <Col span={4} className='stm-text-align-right'>
                                                                <img
                                                                    className='stm-height-40 stm-width-40'
                                                                    src={require('../../assets/image/CloseModal.svg')}
                                                                    alt='closemodal'
                                                                    onClick={this.close} />
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <React.Fragment>
                                                        <Col
                                                            span={24}
                                                            className='stm-margin-bottom-5'
                                                            style={{
                                                                fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                color: activeTemplate.templateSetting.text.color,
                                                                fontSize: activeTemplate.templateSetting.text.fontSize,
                                                                lineHeight: `${activeTemplate.templateSetting.text.fontSize + 4}px`
                                                            }}
                                                        >
                                                            <span>{webSettting.preferredTimeText}: {orderDetail.deliveryTime}</span>
                                                        </Col>
                                                    </React.Fragment>
                                                    <Col
                                                        span={24}
                                                        className='stm-margin-bottom-5'
                                                        style={{
                                                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                            color: activeTemplate.templateSetting.text.color,
                                                            fontSize: activeTemplate.templateSetting.text.fontSize,
                                                            lineHeight: `${activeTemplate.templateSetting.text.fontSize + 4}px`
                                                        }}
                                                    >
                                                        <span>
                                                            {
                                                                orderDetail.remark === ''
                                                                    ?
                                                                    `Description: ${orderDetail.summaryRemark === '' ? '-' : orderDetail.summaryRemark}`
                                                                    :
                                                                    `Description: ${orderDetail.remark} ${orderDetail.summaryRemark === '' ? '' : orderDetail.summaryRemark}`
                                                            }
                                                        </span>
                                                    </Col>
                                                </Row>
                                        }
                                    </>
                                    :
                                    null
                            }
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default withTranslation()(OrderDetailModal)